import { Flex, Spin } from "antd"

const Loader = () => {
  return (
    <Flex justify="center">
      <Spin size="small" />
    </Flex>
  )
}

export default Loader
